import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DetailField } from './InfoCard';
import { SectionCard } from './SectionCard';
import { configurationReadinessView } from '../utils/configurationReadiness';

export function TenantConfigurationReadinessCard({ readiness }) {
  const { t, i18n } = useTranslation(['tenants', 'common']);
  const view = configurationReadinessView(readiness);
  const empty = t('common:empty_value');

  const reportedAt = readiness?.reported_at
    ? new Date(readiness.reported_at).toLocaleString(i18n.language)
    : empty;

  return (
    <SectionCard
      variant="Default"
      title={t('tenants:configuration_readiness.title')}
      subtitle={t('tenants:configuration_readiness.separate_from_checklist')}
      sx={{ mt: 2, mb: 0 }}
    >
      {view.state === 'waiting_for_admin_activation' && (
        <Box data-testid="tenant-configuration-waiting">
          {t('tenants:configuration_readiness.waiting_for_admin_activation')}
        </Box>
      )}
      {view.state === 'no_report' && (
        <Box data-testid="tenant-configuration-empty">
          {t('tenants:configuration_readiness.no_report')}
        </Box>
      )}
      {view.showCounts && (
        <Box
          data-testid="tenant-configuration-counts"
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
            gap: 2.5,
          }}
        >
          <DetailField
            label={t('tenants:configuration_readiness.required')}
            value={t('tenants:configuration_readiness.count_of', {
              completed: readiness.required_completed,
              total: readiness.required_total,
            })}
          />
          <DetailField
            label={t('tenants:configuration_readiness.optional_addressed')}
            value={t('tenants:configuration_readiness.count_of', {
              completed: readiness.optional_addressed,
              total: readiness.optional_total,
            })}
          />
          <DetailField
            label={t('tenants:configuration_readiness.not_applicable')}
            value={String(readiness.not_applicable_count)}
          />
          <DetailField
            label={t('tenants:configuration_readiness.reported_at')}
            value={reportedAt}
          />
        </Box>
      )}
    </SectionCard>
  );
}
